import { setHeaders } from "API/axios";
import { successLogin } from "context/userSlice";
import { AppDispatch } from "context/store";

export default function setHeadersAndUser(
  dispatch: AppDispatch,
  data: RefreshTokenResponse
) {
  setHeaders(data?.accessToken);
  dispatch(successLogin(data?.user));
}
